import { Buffer } from 'buffer'
export const decodedBase64 = (value?: string | null) => {
  return Buffer.from(value || '', 'base64').toString('utf8')
}
export const encodedBase64 = (data: string | number) => {
  return Buffer?.from(data.toString().replaceAll('"', '')).toString('base64')
}
